export default "__VITE_ASSET__1f6dfb22__"